import { Map, Record } from "immutable"
import { Guarantee } from "../../types/primitiveTypes"

type StopType = {
  name: string
  country: string
  code: string
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line no-undef
  duration: moment.Duration
  bagsRecheckRequired: boolean
  hasGuarantee: Guarantee
  isSelfTransfer: boolean
  differentAirport: Map<string, string> | null | undefined
  containsGroundTransport: boolean
  isLayoverBetweenFlights: boolean
  isStopSameCountryAsPrevDeparture: boolean
  isStopBeforeFirstHiddenCity: boolean
}

// eslint-disable-next-line new-cap,babel/new-cap
const StopRecord = Record({
  name: null,
  country: null,
  code: null,
  duration: null,
  bagsRecheckRequired: null,
  hasGuarantee: null,
  isSelfTransfer: null,
  differentAirport: null,
  containsGroundTransport: null,
  isLayoverBetweenFlights: null,
  isStopSameCountryAsPrevDeparture: null,
  isStopBeforeFirstHiddenCity: null,
})

export default class Stop extends StopRecord {
  // @ts-expect-error: Flow to TS migration.
  name: string
  // @ts-expect-error: Flow to TS migration.
  country: string
  // @ts-expect-error: Flow to TS migration.
  code: string
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line no-undef
  duration: moment.Duration
  // @ts-expect-error: Flow to TS migration.
  bagsRecheckRequired: boolean
  // @ts-expect-error: Flow to TS migration.
  hasGuarantee: Guarantee
  // @ts-expect-error: Flow to TS migration.
  isSelfTransfer: boolean
  differentAirport: Map<string, string> | null | undefined
  // @ts-expect-error: Flow to TS migration.
  containsGroundTransport: boolean
  // @ts-expect-error: Flow to TS migration.
  isLayoverBetweenFlights: boolean
  // @ts-expect-error: Flow to TS migration.
  isStopSameCountryAsPrevDeparture: boolean
  // @ts-expect-error: Flow to TS migration.
  isStopBeforeFirstHiddenCity: boolean

  // Constructor isn't useless because it provides a way to check type of data Stop is constructed from
  // eslint-disable-next-line no-useless-constructor
  constructor(data: StopType) {
    super(data)
  }
}
